export enum PageType {
  Home = 'home',
  SRPWithSearchResult = 'srpWithSearchResult',
  SRPWithCategory = 'srpWithCategory',
  VIP = 'vip',
  VIPAfterMessage = 'vipAfterMessage',
}
